import { z } from 'zod'

export const forensicsEnvironmentSchema = z.object({
    name: z.string().min(2, 'Name must be at least 2 characters'),
    vaultId: z.number().int().positive('Please select a vault'),
    securityGroupId: z.string().min(1, 'Security group ID is required'),
    awsAccountId: z.string().min(1, 'AWS account ID is required'),
    description: z.string().optional(),
    servers: z.array(z.object({
        computeObjectId: z.string().min(1, 'Object ID is required'),
        computeObjectVersionId: z.number().optional(),
    })).optional(),
})

export type ForensicsEnvironmentFormData = z.infer<typeof forensicsEnvironmentSchema>
